import { useEffect, useState } from "react";
import { api, fmtINR } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminSubscriptions() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get("/admin/subscriptions").then((r) => setSubs(r.data)); }, []);
  return (
    <div className="p-4 sm:p-6 md:p-8 space-y-6" data-testid="admin-subs-page">
      <div><h1 className="font-display text-3xl font-bold tracking-tight">Subscriptions</h1><p className="text-slate-500">All active and past subscriptions</p></div>
      <Card className="border-slate-200"><CardContent className="p-0 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Store</TableHead><TableHead>Plan</TableHead><TableHead>Amount</TableHead><TableHead>Start</TableHead><TableHead>Expiry</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {subs.map((s) => (
              <TableRow key={s.id}>
                <TableCell className="font-medium">{s.store_name}</TableCell>
                <TableCell>{s.plan_name}</TableCell>
                <TableCell className="font-mono">{fmtINR(s.amount)}</TableCell>
                <TableCell className="text-slate-500 text-sm">{(s.start_date || "").slice(0, 10)}</TableCell>
                <TableCell className="text-slate-500 text-sm">{(s.expiry_date || "").slice(0, 10)}</TableCell>
                <TableCell><Badge className={s.status === "active" ? "bg-emerald-500" : "bg-slate-400"}>{s.status}</Badge></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
